import React, { useState } from 'react';
import { Phone, Mail, MapPin, Building2, ChevronDown, ChevronUp } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const hqOfficers = [
  { sl: 1, name: "Tmt. G.Latha, I.A.S.,", designation: "REGISTRAR OF COOPERATIVE SOCIETIES", phone: "044 - 28364848 / 044 - 48544848", email: "rcs.tn@nic.in" },
  { sl: 2, name: "Thiru. K.Tharpagaraj, I.A.S.,", designation: "ADDITIONAL REGISTRAR (CONSUMER ACTIVITIES)", phone: "044-28364849", email: "arcarcs.2021@gmail.com" },
  { sl: 3, name: "S. Subramanian", designation: "ADDITIONAL REGISTRAR (FINANCE & BANKING)", phone: "044-28364850", email: "arfb.rcs@gmail.com" },
  { sl: 4, name: "C.Srinivasan", designation: "ADDITIONAL REGISTRAR (MARKETING, PLANNING AND DEVELOPMENT)", phone: "044-28364851", email: "armpd.rcs@gmail.com" },
  { sl: 5, name: "V.Devaki", designation: "ADDITIONAL REGISTRAR (ELECTION)", phone: "044-28362013", email: "electionar.rcs@gmail.com" },
  { sl: 6, name: "M.Palanivelu", designation: "ADDITIONAL REGISTRAR (BUDGET & PLANNING)", phone: "044-28364852", email: "aricdp.rcs@gmail.com" },
  { sl: 7, name: "K.P.Vanathi", designation: "JOINT REGISTRAR (FINANCE & BANKING)", phone: "044-28364854", email: "jrfb.rcs@gmail.com" },
  { sl: 8, name: "V. Chamundeeswari", designation: "JOINT REGISTRAR (STATUTORY)", phone: "044-28364855", email: "jrst.rcs@gmail.com" },
  { sl: 9, name: "V.Muralikannan", designation: "JOINT REGISTRAR (CONSUMER COOPERATIVES)", phone: "044-28364853", email: "jrconsumer.rcs@gmail.com" },
  { sl: 10, name: "J. Palaneeswari", designation: "JOINT REGISTRAR / LAW OFFICER (COOPERATION)", phone: "044-28364858 Extn-232", email: "jrlo.rcs@gmail.com" },
  { sl: 11, name: "R.Rameeza Banu", designation: "FINANCIAL ADVISOR AND CHIEF ACCOUNTS OFFICER", phone: "044-28364863", email: "acsection.rcs@gmail.com" },
  { sl: 12, name: "C.Neelakandan", designation: "DEPUTY REGISTRAR / PA TO RCS AND PERSONNEL OFFICER", phone: "044-28364869 Extn - 245", email: "patorcs.tnrcs@gmail.com" },
  { sl: 13, name: "P Shankaramurthy", designation: "DEPUTY REGISTRAR (FINANCE & BANKING)", phone: "044-28364858 Extn - 256", email: "drfb.tnrcs@gmail.com" },
  { sl: 14, name: "E Vijayalakshmi", designation: "DEPUTY REGISTRAR (URBAN COOPERATIVE BANK)", phone: "044-28364858 Extn - 257", email: "bisection.rcs@gmail.com" },
  { sl: 15, name: "M.Uma", designation: "DEPUTY REGISTRAR (PUBLIC DISTRIBUTION SYSTEM)", phone: "044-28364857 Extn - 213", email: "drpdsrcs@gmail.com" },
  { sl: 16, name: "A.Sudha", designation: "DEPUTY REGISTRAR (STATUTORY)", phone: "044 - 28364858 Extn - 212", email: "drsurcharge.rcs@gmail.com" },
  { sl: 17, name: "S.Ranganathan", designation: "DEPUTY REGISTRAR (CMS)", phone: "044-28364858 Extn - 211", email: "gcsection.rcs@gmail.com" },
  { sl: 18, name: "K.Gowri Priya", designation: "DEPUTY REGISTRAR (UNION)", phone: "044-28364858 Extn-259", email: "drresearchcell.rcs@gmail.com" },
  { sl: 19, name: "S.Balasubramanian", designation: "DEPUTY REGISTRAR (CONSUMER COOPERATIVES)", phone: "044-28364858 Extn -217", email: "drconsumer.rcs@gmail.com" },
  { sl: 20, name: "R.Divya", designation: "DEPUTY REGISTRAR (PROJECT MONITORING COMMITTEE)", phone: "044-28364858 Extn - 269", email: "rcs.periodicals@gmail.com" },
  { sl: 21, name: "A N Hema Prakash", designation: "DEPUTY REGISTRAR (ELECTION)", phone: "", email: "coopelection.rcs@gmail.com" },
];

const regionalOffices = [
  {
    sl: "01", region: "Ariyalur",
    jr: { address: "No.213, 214, 2nd Floor, District Collectorate Campus, Ariyalur - 621 704", phone: "04329 - 228333", email: "jralr.rcs@gmail.com" },
    dr: [
      { role: "Deputy Registrar", address: "No.219, 220 2nd Floor, District Collectorate Campus, Ariyalur 621 704", phone: "04329 - 228052", email: "dralr.tnrcs@gmail.com" },
      { role: "Deputy Registrar (PDS)", address: "No.217, 2nd Floor, District, Collectorate, Ariyalur", phone: "04329 - 228051", email: "drpdsalr.tnrcs@gmail.com" },
    ]
  },
  {
    sl: "02", region: "Coimbatore",
    jr: { address: "Arokiyasamy Road, K.K.Pudur, Saibaba Colony, Coimbatore 641 038", phone: "0422 - 2448308", email: "jrcbe.rcs@gmail.com" },
    dr: [
      { role: "Deputy Registrar – Coimbatore Circle", address: "Chinthamani Campus, Coimbatore North, Coimbatore - 641 002", phone: "0422 - 2542316", email: "drcscbe@gmail.com" },
      { role: "Deputy Registrar – Pollachi Circle", address: "Kamarajar Nagar, Mahalingapuram, Pollachi - 642 002", phone: "04259 - 229095", email: "drcspollachi@gmail.com" },
      { role: "Deputy Registrar (PDS)", address: "Arokiyasamy Road, K.K.Pudur, Coimbatore - 641 038", phone: "0422 - 2452595", email: "drpdscbe@gmail.com" },
    ]
  },
  {
    sl: "03", region: "Cuddalore",
    jr: { address: "No.3, Beach Road, Saravanabava Complex, Cuddalore - 1", phone: "04142-222338", email: "jrcud.rcs@gmail.com" },
    dr: [
      { role: "Deputy Registrar – Cuddalore Circle", address: "No 6, Dhandapani Nagar, Semmandalam, Cuddalore", phone: "04142 - 233090", email: "drcud.rcs@gmail.com" },
      { role: "Deputy Registrar – Virudhachalam Circle", address: "No.824/A, Junction Road, Virudhachalam, Cuddalore 606 001", phone: "04143 - 264884", email: "drvdm.rcs@gmail.com" },
      { role: "Deputy Registrar – Chidambaram Circle", address: "50/1, Periyar Street, Chidambaram, Cuddalore District - 608 001", phone: "04144 - 224813", email: "drcbm.rcs@gmail.com" },
      { role: "Deputy Registrar (PDS)", address: "No.3, Beach Road, Saravanabava Complex, Cuddalore-1", phone: "04142-284001", email: "drpdscud123@gmail.com" },
    ]
  },
  {
    sl: "04", region: "Dharmapuri",
    jr: { address: "Cooperative Complex, Collectorate Campus, Dharmapuri - 636 705", phone: "04342-233803", email: "jrdpi.rcs@gmail.com" },
    dr: [
      { role: "Deputy Registrar", address: "Cooperative Complex, Collectorate Campus, Dharmapuri - 636 705", phone: "04342-230095", email: "drdpi.rcs@gmail.com" },
      { role: "Deputy Registrar (PDS)", address: "Cooperative Complex, Collectorate Campus, Dharmapuri - 636 705", phone: "04342-234141", email: "drpdsdpi.rcs@gmail.com" },
    ]
  },
  {
    sl: "05", region: "Dindigul",
    jr: { address: "No.226, 2nd Floor, Collectorate Campus, Dindigul", phone: "0451- 2461734", email: "jrdgl.rcs@gmail.com" },
    dr: [
      { role: "Deputy Registrar", address: "11, State Bank Colony, Nehruji Nagar, Dindigul - 624 001", phone: "0451- 2422207", email: "drdgl.rcs@gmail.com" },
      { role: "Deputy Registrar – Palani Circle", address: "11/223 Rajanagar, Lakshmipuram (Extn), Palani - 624 601", phone: "0451 - 242963", email: "drpln.rcs@gmail.com" },
      { role: "Deputy Registrar (PDS)", address: "235, 2nd Floor, Collectorate Campus, Dindigul - 624 004", phone: "0451 - 2460557", email: "drpdsdgl.rcs@gmail.com" },
    ]
  },
  {
    sl: "06", region: "Erode",
    jr: { address: "District Cooperative Office Complex, 1st floor, Mohankumaramangalam Street, Surampatti, Erode - 638 009", phone: "0424 - 2211378", email: "jrcserode@gmail.com" },
    dr: [
      { role: "Deputy Registrar – Erode Circle", address: "District Cooperative Office Complex, 2nd floor, Mohankumaramangalam Street, Surampatti, Erode 638 009", phone: "0424 - 2216325", email: "drcooperode@gmail.com" },
      { role: "Deputy Registrar – Gobichettipalayam Circle", address: "42 B, Balaji Nagar, Nallagoundenpalayam, Gobichettipalayam - 638 452", phone: "04285 - 240788", email: "drcsgobi@gmail.com" },
      { role: "Deputy Registrar (PDS)", address: "District Cooperative Office Complex, Ground floor, Mohankumaramangalam Street, Surampatti, Erode - 638 009", phone: "0424 - 2214378", email: "drpdserode2gmail.com" },
    ]
  },
  {
    sl: "07", region: "Kancheepuram",
    jr: { address: "(Integrated Cooperative Complex), No.5A, Vandavasi Road, Kancheepuram", phone: "044 - 27238231", email: "jrkpm.rcs@gmail.com" },
    dr: [
      { role: "Deputy Registrar", address: "(Integrated Cooperative Complex), 1st Floor, No.5A, Vandavasi Road, Kancheepuram", phone: "044 - 27238920", email: "drkpm.rcs@gmail.com" },
      { role: "Deputy Registrar (PDS)", address: "(Integrated Cooperative Complex), No.5A, Vandavasi Road, Kancheepuram", phone: "044-27238225", email: "drpdskpm1@gmail.com" },
    ]
  },
  {
    sl: "08", region: "Kanniyakumari",
    jr: { address: "Collectorate Complex, Annexure Building, 2nd Floor, Nagercoil, Kanniyakumari District - 629 001", phone: "04652- 278976", email: "jrkki.rcs@gmail.com" },
    dr: [
      { role: "Deputy Registrar – Nagercoil Circle", address: "Collectorate Complex, Annexure Building, 3rd Floor, Nagercoil, Kanniyakumari District - 629 001", phone: "04652 -225147", email: "drngl.rcs@gmail.com" },
      { role: "Deputy Registrar – Thackalay Circle", address: "No.15/29, Palace Road, Thackalay, Kanniyakumari District - 629 175", phone: "04651-253866", email: "drthuckalay@gmail.com" },
      { role: "Deputy Registrar (PDS)", address: "Collectorate Complex, Annexure Building, IInd Floor, Nagercoil, Kanniyakumari District - 629 001", phone: "04652-278257", email: "jrkki.rcs@gmail.com" },
    ]
  },
  {
    sl: "09", region: "Karur",
    jr: { address: "Integrated Cooperative Complex, Collectorate Campus, District Police Office Backside, Karur - 639 007", phone: "04324-296138", email: "jrkrr.rcs@gmail.com" },
    dr: [
      { role: "Deputy Registrar – Karur Circle", address: "Integrated Cooperative Complex, Collectorate Campus, District Police Office Backside, Karur - 639 007", phone: "04324 - 296065", email: "drkrr.rcs@gmail.com" },
      { role: "Deputy Registrar – Kulithalai Circle", address: "No.101, Peralamman Kovil Street, Kaveri Nagar, Kulithalai 639 104", phone: "04323-222388", email: "drkli.rcs@gmail.com" },
      { role: "Deputy Registrar (PDS)", address: "Integrated Cooperative Complex, Collectorate Campus, District Police Office Backside, Karur - 639 007", phone: "04324 - 296545", email: "pdskarur12@gmail.com" },
    ]
  },
  {
    sl: "10", region: "Krishnagiri",
    jr: { address: "No.24/43, 4th Cross Cooperative Colony, West Link Road, Krishnagiri - 635 001", phone: "04343-236 006", email: "jroffice.kri@gmail.com" },
    dr: [
      { role: "Deputy Registrar", address: "No.2A K.P.K. Complex, 4th Cross Coop. Colony, Krishnagiri 635 001", phone: "04343 - 236248", email: "drcoop.kgi@gmail.com" },
      { role: "Deputy Registrar – Hosur Circle", address: "No.27/2, Thirumalai Plaza, 2nd Floor, Denkanikottai Main Road, Shanthi Nagar East, Hosur- 634 109", phone: "04344 - 222031", email: "drcshsr@gmail.com" },
      { role: "Deputy Registrar (PDS)", address: "No.523 Gandhi Road, Krishnagiri APCMS Building, Krishnagiri - 635 001", phone: "04343-230015", email: "drpds1krishnagiri@gmail.com" },
    ]
  },
  {
    sl: "11", region: "Madurai",
    jr: { address: "Ground Floor, TPK Road, Near Palanganatham Roundana, Madurai - 3", phone: "0452 - 2530911", email: "jrmdu.rcs@gmail.com" },
    dr: [
      { role: "Deputy Registrar – Madurai Circle", address: "2nd Floor, TPK Road, Near Palanganatham Roundana, Madurai - 625 003", phone: "0452 - 2350999", email: "drmdu.rcs@gmail.com" },
      { role: "Deputy Registrar – Usilampatti Circle", address: "23/4 Rajaram 11th Street, Jawahar Nagar, Pudhu Nagar, Tirumangalam - 625 706", phone: "04549 - 280871", email: "drusi.rcs@gmail.com" },
      { role: "Deputy Registrar (PDS)", address: "1st Floor, TPK Road, Near Palanganatham Roundana, Madurai - 3", phone: "0452 - 2531286", email: "drpds.madurai@gmail.com" },
    ]
  },
  {
    sl: "12", region: "Nagapattinam",
    jr: { address: "Room No.303, 3rd Floor, District Collectorate Complex, Nagapattinam - 611 003", phone: "04365-253056", email: "jrcstnngp@gmail.com" },
    dr: [
      { role: "Deputy Registrar – Nagapattinam Circle", address: "Room No.329, District Collectorate Complex, Nagapattinam - 611 703", phone: "04365 - 225067", email: "drcs.nagai@gmail.com" },
      { role: "Deputy Registrar – Mayiladuthurai Circle", address: "No.30/6B 1st Floor, State Bank of India Opposite, Mayiladuthurai - 609 001", phone: "04364", email: "drcsmyd2009@gmail.com" },
      { role: "Deputy Registrar (PDS)", address: "Room No.303, 3rd Floor, District Collectorate Complex, Nagapattinam - 611 003", phone: "04365 - 253105", email: "drpdsngt12@gmail.com" },
    ]
  },
  {
    sl: "13", region: "Namakkal",
    jr: { address: "Room No:10, 2nd Floor, Collectorate Campus, Tiruchengode Road, Namakkal - 637003", phone: "04286 - 280031", email: "jrcsnmk@yahoo.co.in" },
    dr: [
      { role: "Deputy Registrar – Namakkal Circle", address: "Room No.235, 236 First Floor, District Government Office Additional Building, Namakkal - 637 003", phone: "04286 - 291836", email: "drnmk.rcs@gmail.com" },
      { role: "Deputy Registrar – Tiruchengode Circle", address: "21A, I Floor, Kullan kadu, Pallipalayam Main Road, Koottappalli, Tiruchengode - 637 214", phone: "04288-251860", email: "drtcode@gmail.com" },
      { role: "Deputy Registrar (PDS)", address: "No.9, IInd Floor, District Collector Office Campus, Namakkal - 637 003", phone: "04286 - 280272", email: "drpdsnmk.rcs@gmail.com" },
    ]
  },
  {
    sl: "14", region: "Nilgiris",
    jr: { address: "Block IV Additional Collectorate Campus, Finger Post, Udhagamandalam 643 006", phone: "0423 - 2442586", email: "jrngs.rcs@gmail.com" },
    dr: [
      { role: "Deputy Registrar – Udhagamandalam Circle", address: "Block IV Additional Collectorate Campus, Finger Post, Udhagamandalam, Nilgiris District - 643 006", phone: "0423 2444001", email: "droty.rcs@gmail.com" },
      { role: "Deputy Registrar (PDS)", address: "Block IV Additional Collectorate Campus, Finger Post, Udhagamandalam, Nilgiris District - 643 006", phone: "0423 - 2442676", email: "drpds.ngsoty@gmail.com" },
    ]
  },
  {
    sl: "15", region: "Perambalur",
    jr: { address: "Integrated Cooperative Complex, District Collectorate Complex Backside, Perambalur - 621 212", phone: "04328 - 296151", email: "jrplr.rcs@gmail.com" },
    dr: [
      { role: "Deputy Registrar – Perambalur Circle", address: "Integrated Cooperative Complex, District Collectorate Complex Backside, Perambalur - 621 212", phone: "296126", email: "pblrdroffice@gmail.com" },
      { role: "Deputy Registrar (PDS)", address: "Integrated Cooperative Complex, District Collectorate Complex Backside, Perambalur - 621 212", phone: "04328 - 296140", email: "drpds.pblr@gmail.com" },
    ]
  },
  {
    sl: "16", region: "Pudukkottai",
    jr: { address: "Integrated Cooperative Office Complex, Collector Office Near, Annavasai Road, Pudukkottai - 622 002", phone: "04322 - 236089", email: "jrpdk.rcs@gmail.com" },
    dr: [
      { role: "Deputy Registrar – Pudukkottai Circle", address: "Integrated Cooperative Office Complex, Collector Office Near, Annavasai Road, Pudukkottai - 622 002", phone: "04322 - 236273", email: "drpdk.rcs@gmail.com" },
      { role: "Deputy Registrar – Aranthangi Circle", address: "No.24 Kamatchi Amman Kovil Street, Aranthangi - 614 616", phone: "04371 - 220608", email: "drart.rcs@gmail.com" },
      { role: "Deputy Registrar (PDS)", address: "Integrated Cooperative Office Complex, Collector Office Near, Annavasai Road, Pudukkottai 622 002", phone: "04322 -236091", email: "drpdspdk3@gmail.com" },
    ]
  },
  {
    sl: "17", region: "Ramanathapuram",
    jr: { address: "Collectorate Complex, Treasury Building, 1st Floor, Ramanathapuram - 623 503", phone: "04567 - 231168", email: "jrrmd.rcs@gmail.com" },
    dr: [
      { role: "Deputy Registrar – Ramanathapuram Circle", address: "K.T.M. Complex, Salai Street, Ramanathapuram -623 501", phone: "04567 -221852", email: "drrmd.rcs@gmail.com" },
      { role: "Deputy Registrar – Paramakudi Circle", address: "No.2/421 B, Bhagavathsingh Road, Near Ottapalam Bus Stop, Paramakudi 623 707", phone: "04564 -226783", email: "drpmk.rcs@gmail.com" },
      { role: "Deputy Registrar (PDS)", address: "Collectorate Complex, Treasury Building, 1st Floor, Ramanathapuram -623 503", phone: "04567 -230950", email: "jrrmd.rcs@gmail.com" },
    ]
  },
  {
    sl: "18", region: "Salem",
    jr: { address: "Room No.410, 4th Floor, District Collectorate Office, Salem - 636 001", phone: "0427 - 2415158", email: "jrslm.rcs@gmail.com" },
    dr: [
      { role: "Deputy Registrar – Salem Circle", address: "Salem District Central Cooperative Bank Compound, No.63, Cherry Road, Salem -636 001", phone: "0427 - 2452011", email: "drslm.rcs@gmail.com" },
      { role: "Deputy Registrar – Attur Circle", address: "No.79 H, 2nd Floor, AKS Complex, Cuddalore Main Road, Attur Taluk, Salem District -636 108", phone: "04282 - 240610", email: "dratr.rcs@gmail.com" },
      { role: "Deputy Registrar – Omalur Circle", address: "No.193/11W, Cutchery Street, Omalur Taluk, Salem District -636 455", phone: "04290 - 222959", email: "drcsomalur@gmail.com" },
      { role: "Deputy Registrar – Sankagiri Circle", address: "No.1/47, Kalaimagal Building, Old Edappadi Road, Sankagiri -637 301", phone: "04283 - 243600", email: "drcssankagiri@gmail.com" },
      { role: "Deputy Registrar (PDS)", address: "Room No.308, 3rd Floor, District Collectorate Office, Salem -636 001", phone: "0427 - 2415784", email: "drpdsslm@gmail.com" },
    ]
  },
  {
    sl: "19", region: "Sivagangai",
    jr: { address: "Integrated Cooperative Complex, Collectorate Unit II, Opp. to Government Womens Arts College, Kanjirangal, Sivagangai - 630 562", phone: "04575 - 240417", email: "jrsvg.rcs@gmail.com" },
    dr: [
      { role: "Deputy Registrar – Sivagangai Circle", address: "Integrated Cooperative Complex, Collectorate Unit II, Opp. to Government Womens Arts College, Kanjirangal, Sivagangai -630 562", phone: "04575 -240258", email: "drsvg.rcs@gmail.com" },
      { role: "Deputy Registrar – Karaikudi Circle", address: "No.51, Muthulakshmi Illam, Govindarajlu Road, Aruna Nagar, Karaikudi -630 001", phone: "04565 - 238946", email: "drkkd.rcs@gmail.com" },
      { role: "Deputy Registrar (PDS)", address: "Integrated Cooperative Complex, Collectorate Unit II, Opp. to Government Womens Arts College, Kanjirangal, Sivagangai -630 562", phone: "04575 - 241166", email: "drpds.svg@gmail.com" },
    ]
  },
  {
    sl: "20", region: "Thanjavur",
    jr: { address: "Samiappa Institute of Cooperative Management Campus, Medical College Road, Thanjavur - 613 007", phone: "04362 - 231238", email: "jrcstnj@gmail.com" },
    dr: [
      { role: "Deputy Registrar – Thanjavur Circle", address: "Samiappa Institute of Cooperative Management Campus, Thanjavur -613 007", phone: "04362 -231237", email: "drtnj.rcs@gmail.com" },
      { role: "Deputy Registrar – Kumbakonam Circle", address: "No.72/36, Sarangapani Sannathi Street, Kumbakonam - 612 001", phone: "0435 -2420330", email: "drkmb.rcs@gmail.com" },
      { role: "Deputy Registrar – Pattukottai Circle", address: "No.8 Jeyaraj Complex 2nd Floor, Chinnaiah Street, Pattukottai, Thanjavur District -614 601", phone: "04373 -252076", email: "drpkt.rcs@gmail.com" },
      { role: "Deputy Registrar (PDS)", address: "Samiappa Institute of Cooperative Management Campus, Medical College Road, Thanjavur -613 007", phone: "04362 -273442", email: "drpdsthanjavur@gmail.com" },
    ]
  },
  {
    sl: "21", region: "Theni",
    jr: { address: "Government Multi Stored Building, 1st Floor, I Block, Theni - 625 531", phone: "04546 - 291929", email: "jrthn.rcs1997@gmail.com" },
    dr: [
      { role: "Deputy Registrar – Uthamapalayam Circle", address: "Cooperative Land and Develop Bank Upstairs, South Raja Street, Uthamapalayam -625 533", phone: "04554 -265872", email: "drupm.rcs@gmail.com" },
      { role: "Deputy Registrar – Periyakulam Circle", address: "JRR Nagar, Vaigai Dam Road, Periyakulam -625 501", phone: "04546 -231262", email: "drpkm.tnrcs@gmail.com" },
      { role: "Deputy Registrar (PDS)", address: "Government Multi Stored Building, 1st Floor, 1st Block, Theni -625 531", phone: "04546 -291989", email: "drpds.thn2021@gmail.com" },
    ]
  },
  {
    sl: "22", region: "Thoothukudi",
    jr: { address: "39B, 1st Floor, Annai Nursing Societies Upstair, T.R.Naidu Street, Thoothukudi - 628 002", phone: "0461 - 2324610", email: "jrcooptuty@gmail.com" },
    dr: [
      { role: "Deputy Registrar – Thoothukudi Circle", address: "No.137, Polpettai, Thoothukudi APCMS Complex, Ettaiyapuram Road, Thoothukudi -628 002", phone: "0461 - 2320192", email: "drttn.rcs@gmail.com" },
      { role: "Deputy Registrar – Tiruchendur Circle", address: "No.1/138, Medona Street, Veerapandiyan Pattanam, Tiruchendur 628 216", phone: "04639 - 242294", email: "drtdr.rcs@gmail.com" },
      { role: "Deputy Registrar – Kovilpatti Circle", address: "Door No.54, Ettaiyapuram Road, Head Post Office Opposite, Kovilpatti -628 502", phone: "04632 - 220370", email: "drkvp.rcs@gmail.com" },
      { role: "Deputy Registrar (PDS)", address: "39B, 1st Floor, Annai Nursing Societies Upstair, T.R.Naidu Street, Thoothukudi -628 002", phone: "0461 - 2327151", email: "jrttn.rcs@gmail.com" },
    ]
  },
  {
    sl: "23", region: "Trichirapalli",
    jr: { address: "2nd Floor Multi Store Mannapuram, Trichirapalli - 620 020", phone: "0431 - 2420545", email: "jrtry.rcs@gmail.com" },
    dr: [
      { role: "Deputy Registrar – Trichirapalli Circle", address: "2nd Floor Multi Store Mannapuram, Trichy -620 020", phone: "0431 -2420578", email: "drtry.rcs@gmail.com" },
      { role: "Deputy Registrar – Lalgudi Region", address: "No.96, Main Road, Lalgudi -621 601", phone: "0431 -2424170", email: "drcsgt@gmail.com" },
      { role: "Deputy Registrar – Musiri Circle", address: "No.218/4 College Road, Melavadugapatti, Musiri -621211", phone: "", email: "drmusiri@gmail.com" },
      { role: "Deputy Registrar (PDS)", address: "2nd Floor, Multi Store, Mannapuram, Trichirapalli -620 020", phone: "0431 2424170", email: "drpdstrichy2021@gmail.com" },
    ]
  },
  {
    sl: "24", region: "Tirunelveli",
    jr: { address: "No.1 Meignana Street, Palayamkottai, Tirunelveli - 2", phone: "0462 - 2560575", email: "jrcstny@gmail.com" },
    dr: [
      { role: "Deputy Registrar – Tirunelveli Circle", address: "C -91 Second Cross Street, Maharajanagar, Tirunelveli -627 011", phone: "0462-2574920", email: "drcstvl2530970@gmail.com" },
      { role: "Deputy Registrar – Cheranmadevi Circle", address: "No.17-B, Sannathi Street, Railway Feeder Road, Cheranmadevi -627 414", phone: "04634-261976", email: "drcscmd@gmail.com" },
      { role: "Deputy Registrar (PDS)", address: "No.1 Meignana Street, Palayamkottai, Tirunelveli -627 002", phone: "0462 -2560513", email: "drpdstnv@gmail.com" },
    ]
  },
  {
    sl: "25", region: "Tiruppur",
    jr: { address: "Room No.407, IVth Floor, District Collectorate Campus, Palladam Road, Tiruppur - 641 604", phone: "0421 - 2971184", email: "jrcooptiruppur@gmail.com" },
    dr: [
      { role: "Deputy Registrar – Tiruppur Circle", address: "Tiruppur Agricultural Producers Cooperative Marketing Society Compound, No.377, Kamarajar Salai, Palladam Main Road, Tiruppur -641 604", phone: "0421 -2216355", email: "drcooptiruppur@gmail.com" },
      { role: "Deputy Registrar – Dharapuram Circle", address: "Dharapuram Agricultural Producers Cooperative Marketing Society Compound, No.487, Chinnakadai Street, Dharapuram 638 656", phone: "04258 - 221795", email: "drdpm.rcs@gmail.com" },
      { role: "Deputy Registrar (PDS)", address: "Room No.403, IVth Floor, District Collectorate Campus, Palladam Road, Tiruppur -641 604", phone: "0421 -2971173", email: "drpdstpr@gmail.com" },
    ]
  },
  {
    sl: "26", region: "Tiruvallur",
    jr: { address: "District Collectorate Campus (Back Side), Tiruvallur - 602 001", phone: "044 - 27662622", email: "jrtlr.rcs@gmail.com" },
    dr: [
      { role: "Deputy Registrar – Tiruvallur Circle", address: "District Collectorate Campus (Back Side), Tiruvallur -602 001", phone: "044 -27660283", email: "drtlr.rcs@gmail.com" },
      { role: "Deputy Registrar – Thiruthani Circle", address: "No.12, K.C.Chetty Street, (Opp) Railway Station", phone: "044 -27885511", email: "drtni.rcs@gmail.com" },
      { role: "Deputy Registrar – Ponneri Circle", address: "No.6, Taulk Office Road, LIC (Back Side), Ponneri -601 204", phone: "044 -27974081", email: "drpon.rcs@gmail.com" },
      { role: "Deputy Registrar (PDS)", address: "District Collectorate Campus (Back Side), Tiruvallur -602 001", phone: "044 -27665070", email: "drpdstlr@gmail.com" },
    ]
  },
  {
    sl: "27", region: "Tiruvannamalai",
    jr: { address: "District Collectorate Master Plan Complex, Vengikkal Post, Tiruvannamalai - 606 604", phone: "04175 - 298341", email: "jrtvm.rcs@gmail.com" },
    dr: [
      { role: "Deputy Registrar – Tiruvannamalai Circle", address: "District Collectorate Master Plan Complex, Vengikkal Post, Tiruvannamalai -606 604", phone: "04175 -298342", email: "drtvm.rcs@gmail.com" },
      { role: "Deputy Registrar – Cheyyar Circle", address: "Jeeyar Street, No.74, Keezhpudhupakkam Road, Tiruvannamalai District, Cheyyar - 604 407", phone: "04182 -220114", email: "drcscheeyyar@gmail.com" },
      { role: "Deputy Registrar (PDS)", address: "District Collectorate Master Plan Complex, Vengikkal Post, Tiruvannamalai -606 604", phone: "04175 -298343", email: "drpdstvm@gmail.com" },
    ]
  },
  {
    sl: "28", region: "Tiruvarur",
    jr: { address: "Integrated Cooperative Complex, (Behind Thiruvarur Government Medical College), District Collectorate Master Complex, Thandalai, Tiruvarur - 610 004", phone: "04366 - 290773", email: "jrtvr.rcs@gmail.com" },
    dr: [
      { role: "Deputy Registrar – Thiruvarur Circle", address: "Integrated Cooperative Complex, (Behind Thiruvarur Government Medical College), District Collectorate Master Complex, Thandalai, Thiruvarur -610 004", phone: "04366 -290772", email: "drcstvrr@gmail.com" },
      { role: "Deputy Registrar – Mannarkudi Circle", address: "No.5/152, Thirumakottai Main Road, (Upstair Tamil Nadu Merkandail Bank), Jothi Nagar, Ashesam, Mannarkudi -614 001", phone: "04367 - 252346", email: "drcsmng@yahoo.com" },
      { role: "Deputy Registrar (PDS)", address: "Integrated Cooperative Complex, (Behind Thiruvarur Government Medical College), District Collectorate Master Complex, Thandalai, Tiruvarur -610 004", phone: "04366 -222221", email: "thiruvarurdrpds@gmail.com" },
    ]
  },
  {
    sl: "29", region: "Vellore",
    jr: { address: "Vellore District Collectorate Campus, No.405, A-Block, Sathuvachari, Vellore - 632 009", phone: "0416 - 2253086", email: "jrvlr.rcs@gmail.com" },
    dr: [
      { role: "Deputy Registrar – Vellore Circle", address: "No.6, Thulasingam Street, Sankaranpalayam, Vellore - 632 001", phone: "0416 -2263250", email: "drvlr.rcs@gmail.com" },
      { role: "Deputy Registrar (PDS)", address: "Vellore District Collectorate Campus, No.405, `A` Block, Sathuvachari, Vellore -632 009", phone: "0416 -2253009", email: "drpds.vlr@gmail.com" },
    ]
  },
  {
    sl: "30", region: "Villupuram",
    jr: { address: "Master Plan Complex District Collectorate Campus, Villupuram - 605 602", phone: "04146 - 222289", email: "jrvpm.rcs@gmail.com" },
    dr: [
      { role: "Deputy Registrar – Villupuram Circle", address: "Master Plan Complex District Collectorate Campus, Villupuram -605 602", phone: "04146-250700", email: "codeputy123vpm@gmail.com" },
      { role: "Deputy Registrar – Dindivanam Circle", address: "No.18, First Floor, First Cross, Jayapuram, Dindivanam -604 002", phone: "04147 - 222812", email: "drtdm.rcs@gmail.com" },
      { role: "Deputy Registrar (PDS)", address: "Master Plan Complex District Collectorate Campus, Villupuram -605 602", phone: "04146 -33985", email: "drpdsvpm@gmail.com" },
    ]
  },
  {
    sl: "31", region: "Virudhunagar",
    jr: { address: "C - 1 - 3 Block 1st Floor, Master Plan Complex Collectorate, Virudhunagar - 626 002", phone: "04562 - 252680", email: "jrvnr.rcs@gmail.com" },
    dr: [
      { role: "Deputy Registrar – Aruppukottai Circle", address: "137 B, KPV Complex 2nd Floor, Pandalgudi Road, Aruppukottai -626 101", phone: "04566 - 228220", email: "drcsapk@gmail.com" },
      { role: "Deputy Registrar – Srivilliputhur Circle", address: "No.2H/2H1, Kalaiyar Kurchi Street, Madavar Valagam, Srivilliputhur -626 125", phone: "04563 - 260312", email: "drcssvpr@gmail.com" },
      { role: "Deputy Registrar (PDS)", address: "No.C-1 3rd Block 1st Floor, Master Plan Complex, Collectorate, Virudhunagar - 626 002", phone: "04562 - 252680", email: "jrvnr.rcs@gmail.com" },
    ]
  },
  {
    sl: "32", region: "Chennai (Additional Registrar)",
    jr: { address: "No.91, St.Marys Road, Abiramapuram, Chennai - 600 018", phone: "044 - 24616503", email: "archn.rcs@gmail.com" },
    dr: [
      { role: "Deputy Registrar (Credit)", address: "2nd Floor, Kuralagam, Broadway, Chennai -600 108", phone: "044 -25343331", email: "drchc.rcs@gmail.com" },
      { role: "Deputy Registrar (Non Credit)", address: "2nd Floor, Kuralagam, Broadway, Chennai -600 108", phone: "25330807", email: "drchn.rcs@gmail.com" },
    ]
  },
  {
    sl: "33", region: "Chennai PDS North",
    jr: { address: "1st Floor, Kuralagam, Broadway, Chennai - 600 108", phone: "25353034", email: "jrpdsnorth@gmail.com" },
    dr: [
      { role: "Deputy Registrar (PDS) Park Town -1", address: "G133 1st Main Road, Chinthamani Complex, Anna Nagar East, Chennai -600 102", phone: "26630921", email: "drpdsparktown1@gmail.com" },
      { role: "Deputy Registrar (PDS) Park Town -2", address: "G133 1st Main Road, Chinthamani Complex, Anna Nagar East, Chennai -600 102", phone: "", email: "drpdsparktowntwo@gmail.com" },
      { role: "Deputy Registrar (PDS) Primaries North", address: "No.58, Ebrahim Street, Chennai -600 001", phone: "044 -25287103", email: "drpdsoffice@gmail.com" },
    ]
  },
  {
    sl: "34", region: "Chennai PDS South",
    jr: { address: "3A, 3rd floor, Aavin Illam, Pasumpon Muthuramalinganar Salai, Nandanam, Chennai-600035", phone: "044 - 23651721", email: "jrpds2.rcs@gmail.com" },
    dr: [
      { role: "Deputy Registrar (PDS) Triplicane -1", address: "156 Big Street, Triplicane, Chennai -5", phone: "044 - 23453414", email: "drpds1@gmail.com" },
      { role: "Deputy Registrar (PDS) Triplicane -2", address: "156 Big Street, Triplicane, Chennai -5", phone: "044 - 23453414", email: "drpds2@gmail.com" },
      { role: "Deputy Registrar (PDS) Belt", address: "No.185, Prakasam Salai, Broadway, Chennai -600 108", phone: "", email: "drpdsbelt@gmail.com" },
      { role: "Deputy Registrar (PDS) Primaries South", address: "No.91, St.Mary's Road, R.A.Puram, Chennai -600 018", phone: "044 - 24612018", email: "drprisouth@gmail.com" },
    ]
  },
  {
    sl: "35", region: "Kallakurichi",
    jr: { address: "1st Floor, No.176, Periyar Nagar, V.Palayam, (Near Kallakurichi Toll Plaza), Madur (Post), Kallakurichi - 606 206", phone: "04151 – 222323", email: "jrkak.rcs@gmail.com" },
    dr: [
      { role: "Deputy Registrar – Kallakurichi", address: "1st Floor, No.176, Periyar Nagar, V.Palayam, (Near Kallakurichi Toll Plaza), Madur (Post), Kallakurichi - 606 206", phone: "04151 – 225576", email: "drkak.rcs@gmail.com" },
      { role: "Deputy Registrar – Thirukovilur", address: "No.20/3, Teacher Nagar, Santhaipettai, Tirukoilur - 605 766", phone: "04153 – 252345", email: "drtrk.rcs@gmail.com" },
      { role: "Deputy Registrar (PDS)", address: "1st Floor, No.176, Periyar Nagar, V.Palayam, (Near Kallakurichi Toll Plaza), Madur (Post), Kallakurichi - 606 206", phone: "04151 -226422", email: "drpdskak@gmail.com" },
    ]
  },
  {
    sl: "36", region: "Chengalpet",
    jr: { address: "No.264/1, Greenland, Thirukazhukundram Road, Vallam Post, Chengalpet, 603002", phone: "044 -27426604", email: "jrcgt.rcs@gmail.com" },
    dr: [
      { role: "Deputy Registrar – Chengalpet", address: "No.10A, 1st floor, Anna nagar, Chengalpet – 603001", phone: "044 27431493", email: "drcgt.rcs@gmail.com" },
      { role: "Deputy Registrar (PDS)", address: "No.264/1, Greenland, Thirukazhukundram Road, Vallam Post, Chengalpet, 603002", phone: "", email: "drpdscpt1@gmail.com" },
      { role: "Deputy Registrar – Madurandhagam Circle", address: "No.50, Hospital Road, Opp. Hindu Higher Secondary School, Madurandhagam - 603 306", phone: "044 - 27553059", email: "drmkm.rcs@gmail.com" },
    ]
  },
  {
    sl: "37", region: "Mayiladuthurai",
    jr: { address: "BSNL campus, No.14, Thennamara salai, Thiruvizhandur, Mayiladuthurai district- 609001", phone: "", email: "jrcs.tnmld@gmail.com" },
    dr: [
      { role: "Deputy Registrar – Mayiladuthurai", address: "30/6B, 1ST floor, Deen Plaza complex, State Bank road, Mayiladuthurai-609001", phone: "04364224302", email: "drmld.rcs@gmail.com" },
      { role: "Deputy Registrar (PDS)", address: "BSNL campus, No.14, Thennamara salai, Thiruvizhandur, Mayiladuthurai district- 609001", phone: "", email: "drpdsmyd@gmail.com" },
    ]
  },
  {
    sl: "38", region: "Tenkasi",
    jr: { address: "No.254/5, RailNagar road, Jayam nagar, Thenkasi district- 627811", phone: "04633-298101", email: "jrtenkasi@gmail.com" },
    dr: [
      { role: "Deputy Registrar – Tenkasi", address: "No.135/10,11, Shenbagavinayagar Kovil Street, Temple Tower near old Bus stand, Tenkasi -627811", phone: "04633-227088", email: "drtsi.rcs@gmail.com" },
      { role: "Deputy Registrar – Sankarankovil", address: "382/2, Rajapalayam Road, Sankarankovil -627756", phone: "04636-210658", email: "drcssnkl@gmail.com" },
      { role: "Deputy Registrar (PDS)", address: "No.254/5, RailNagar road, Jayam nagar, Thenkasi district- 627811", phone: "04633-298102", email: "drpdstenkasi123@gmail.com" },
    ]
  },
  {
    sl: "39", region: "Tirupathur",
    jr: { address: "4th Floor, A block, Collectorate Campus, Tirupathur District -635601", phone: "", email: "jrtptr.rcs@gmail.com" },
    dr: [
      { role: "Deputy Registrar – Tirupathur", address: "4th Floor, A block, Collectorate Campus, Tirupathur District -635601", phone: "9942990567", email: "drcooperatives.tpt.rcs@gmail.com" },
      { role: "Deputy Registrar (PDS)", address: "4th Floor, A block, Collectorate Campus, Tirupathur District -635601", phone: "", email: "drpdstpt.rcs@gmail.com" },
    ]
  },
  {
    sl: "40", region: "Ranipet",
    jr: { address: "No.14, Arcot Road, Opp to Rajeswari Theatre, Ranipet district- 631403", phone: "04172 - 272277", email: "jrrpt.rcs@gmail.com" },
    dr: [
      { role: "Deputy Registrar – Ranipet", address: "'A' Block, 3rd floor, District Collectorate, Ranipet", phone: "04172- 270050", email: "drrpt.rcs@gmail.com" },
      { role: "Deputy Registrar (PDS)", address: "'A' Block, 3rd Floor, Collectorate Campus, Bharathi Nagar, Ranipet - 632 403", phone: "04172- 272721", email: "drpdsrpt.rcs@gmail.com" },
    ]
  },
];

const RegionalRow = ({ office }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="border border-slate-200 rounded-xl overflow-hidden mb-3 shadow-sm">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between px-5 py-4 bg-white hover:bg-blue-50 transition-colors"
      >
        <div className="flex items-center gap-3">
          <span className="w-8 h-8 rounded-full bg-gradient-to-br from-[#005A8D] to-[#0077B6] text-white text-xs font-bold flex items-center justify-center flex-shrink-0">
            {office.sl}
          </span>
          <div className="text-left">
            <p className="font-semibold text-[#005A8D] text-sm">{office.region} Region</p>
          </div>
        </div>
        {open ? <ChevronUp className="w-4 h-4 text-[#005A8D]" /> : <ChevronDown className="w-4 h-4 text-[#005A8D]" />}
      </button>

      {open && (
        <div className="bg-slate-50 px-5 py-4 border-t border-slate-200">
          {/* JR Office */}
          <div className="mb-4">
            <p className="text-xs font-bold text-[#005A8D] uppercase tracking-wide mb-2">Joint Registrar Office</p>
            <div className="bg-white rounded-lg p-4 border-l-4 border-[#005A8D]">
              <div className="flex flex-wrap gap-4 text-sm">
                <div className="flex items-start gap-2">
                  <MapPin className="w-3.5 h-3.5 text-[#005A8D] mt-0.5 flex-shrink-0" />
                  <span className="text-gray-700">{office.jr.address}</span>
                </div>
                {office.jr.phone && (
                  <div className="flex items-center gap-2">
                    <Phone className="w-3.5 h-3.5 text-[#005A8D] flex-shrink-0" />
                    <a href={`tel:${office.jr.phone}`} className="text-gray-700 hover:text-[#005A8D]">{office.jr.phone}</a>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* DR Offices */}
          <div>
            <p className="text-xs font-bold text-[#005A8D] uppercase tracking-wide mb-2">Deputy Registrar Offices</p>
            <div className="space-y-2">
              {office.dr.map((dr, idx) => (
                <div key={idx} className="bg-white rounded-lg p-3 border-l-4 border-amber-400">
                  <p className="text-xs font-semibold text-amber-700 mb-1">{dr.role}</p>
                  <div className="flex flex-wrap gap-3 text-xs text-gray-600">
                    <div className="flex items-start gap-1.5">
                      <MapPin className="w-3 h-3 text-amber-500 mt-0.5 flex-shrink-0" />
                      <span>{dr.address}</span>
                    </div>
                    {dr.phone && (
                      <div className="flex items-center gap-1.5">
                        <Phone className="w-3 h-3 text-amber-500 flex-shrink-0" />
                        <a href={`tel:${dr.phone}`} className="hover:text-[#005A8D]">{dr.phone}</a>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const ContactUs = () => {
  const { language } = useLanguage();

  const content = {
    en: {
      pageTitle: "Contact Us",
      pageSubtitle: "Get in touch with the Office of the Registrar of Cooperative Societies, Tamil Nadu",
      hqTitle: "Head Office",
      hqAddress: "NV Natarajan Maligai, No.170, Periyar E.V.R. High Road, Kilpauk, Chennai - 600 010, Tamilnadu",
      officersTitle: "Officers at Head Office",
      regionalTitle: "Regional & Circle Offices",
      regionalSubtitle: "Click on a region to view Joint Registrar and Deputy Registrar contact details",
    },
    ta: {
      pageTitle: "தொடர்பு கொள்ளுங்கள்",
      pageSubtitle: "தமிழ்நாடு கூட்டுறவுச் சங்கங்கள் பதிவாளர் அலுவலகத்தை தொடர்பு கொள்ளுங்கள்",
      hqTitle: "தலைமை அலுவலகம்",
      hqAddress: "என்வி நடராஜன் மாளிகை, எண்.170, பெரியார் ஈ.வெ.ர். உயர்நெடுஞ்சாலை, கிழக்கம்பாக்கம், சென்னை - 600 010, தமிழ்நாடு",
      officersTitle: "தலைமை அலுவலக அதிகாரிகள்",
      regionalTitle: "பிராந்திய மற்றும் வட்ட அலுவலகங்கள்",
      regionalSubtitle: "கூட்டு பதிவாளர் மற்றும் துணை பதிவாளர் தொடர்பு விவரங்களைப் பார்க்க ஒரு பிராந்தியத்தை கிளிக் செய்யுங்கள்",
    }
  };

  const t = content[language] || content.en;

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-blue-50">
      {/* Hero */}
      <div className="relative bg-gradient-to-r from-[#003d5c] via-[#005A8D] to-[#0077B6] py-10 mt-4 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-64 h-64 bg-white rounded-full -translate-x-1/2 -translate-y-1/2"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full translate-x-1/3 translate-y-1/3"></div>
        </div>
        <div className="relative max-w-6xl mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-3 tracking-tight">{t.pageTitle}</h1>
          <div className="w-24 h-1.5 bg-gradient-to-r from-transparent via-white to-transparent mx-auto mb-4"></div>
          <p className="text-lg text-white/95 max-w-3xl mx-auto font-light leading-relaxed">{t.pageSubtitle}</p>
        </div>
      </div>

      <div className="w-full px-2 md:px-4 py-12">

        {/* HQ Card */}
        <div className="mb-12">
          <div className="bg-white rounded-2xl shadow-2xl overflow-hidden border border-slate-100">
            <div className="bg-gradient-to-r from-[#005A8D] to-[#0077B6] p-6 md:p-8">
              <div className="flex items-center gap-4">
                <div className="p-3 bg-white/20 backdrop-blur-sm rounded-xl">
                  <Building2 className="w-7 h-7 text-white" />
                </div>
                <h2 className="text-2xl md:text-3xl font-bold text-white">{t.hqTitle}</h2>
              </div>
            </div>
            <div className="p-6 md:p-8">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="flex items-start gap-3">
                  <div className="p-2 bg-blue-50 rounded-lg flex-shrink-0">
                    <MapPin className="w-5 h-5 text-[#005A8D]" />
                  </div>
                  <div>
                    <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Address</p>
                    <p className="text-gray-800 text-sm leading-relaxed">{t.hqAddress}</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="p-2 bg-blue-50 rounded-lg flex-shrink-0">
                    <Phone className="w-5 h-5 text-[#005A8D]" />
                  </div>
                  <div>
                    <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Phone</p>
                    <p className="text-gray-800 text-sm">Phone: <a href="tel:04428364858" className="hover:text-[#005A8D]">044 2836 4858</a></p>
                    <p className="text-gray-800 text-sm mt-1">Phone: <a href="tel:04448544848" className="hover:text-[#005A8D]">044 4854 4848</a></p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="p-2 bg-blue-50 rounded-lg flex-shrink-0">
                    <Mail className="w-5 h-5 text-[#005A8D]" />
                  </div>
                  <div>
                    <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Email</p>
                    <a href="mailto:rcs.tn@nic.in" className="text-[#005A8D] text-sm hover:underline">rcs.tn@nic.in</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Officers Table */}
        <div className="mb-12">
          <div className="bg-white rounded-2xl shadow-2xl overflow-hidden border border-slate-100">
            <div className="bg-gradient-to-r from-[#005A8D] to-[#0077B6] p-6 md:p-8">
              <h2 className="text-2xl font-bold text-white">{t.officersTitle}</h2>
            </div>
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="bg-slate-50 border-b border-slate-200">
                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wide w-10">Sl.</th>
                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wide">Name</th>
                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wide">Designation</th>
                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wide">Phone</th>
                  </tr>
                </thead>
                <tbody>
                  {hqOfficers.map((officer, idx) => (
                    <tr key={officer.sl} className={`border-b border-slate-100 hover:bg-blue-50/40 transition-colors ${idx % 2 === 0 ? 'bg-white' : 'bg-slate-50/50'}`}>
                      <td className="px-4 py-3 text-gray-500 text-center font-medium">{officer.sl}</td>
                      <td className="px-4 py-3 text-gray-800 font-medium">{officer.name}</td>
                      <td className="px-4 py-3 text-gray-700">{officer.designation}</td>
                      <td className="px-4 py-3">
                        {officer.phone ? (
                          <a href={`tel:${officer.phone}`} className="text-gray-700 hover:text-[#005A8D] whitespace-nowrap">{officer.phone}</a>
                        ) : <span className="text-gray-400">—</span>}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Regional Offices */}
        <div>
          <div className="bg-white rounded-2xl shadow-2xl overflow-hidden border border-slate-100">
            <div className="bg-gradient-to-r from-[#005A8D] to-[#0077B6] p-6 md:p-8">
              <h2 className="text-2xl font-bold text-white mb-1">{t.regionalTitle}</h2>
              <p className="text-white/80 text-sm">{t.regionalSubtitle}</p>
            </div>
            <div className="p-6 md:p-8">
              {regionalOffices.map((office) => (
                <RegionalRow key={office.sl} office={office} />
              ))}
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default ContactUs;
